import _extends from 'babel-runtime/helpers/extends';

import { grantRevoke } from '@/api/grant/grant';
import Uploader from '@/components/Uploader/index.vue';
import { reduceFileAccept } from '@/common/file';
import { Message } from 'element-ui';
import { PlanType } from '@/common/permission';

export default {
  components: { Uploader: Uploader },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },

    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },

    dialogAttrs: function dialogAttrs() {
      return _extends({}, this.$attrs);
    }
  },
  data: function data() {
    return {
      loading: false,
      formValue: {
        id: 0,
        reason: '',
        image: '',
        url: ''
      },
      rules: {
        reason: [{ required: true, trigger: 'blur', message: '请输入撤销原因' }, { min: 10, message: '请填写不少于10字的撤销原因', trigger: 'blur' }],
        image: [{
          required: true,
          trigger: 'blur',
          message: '请上传截图'
        }]
      },
      uploaderAttr: {
        withCredentials: true,
        data: { bucket: 'mws-files' },
        accept: reduceFileAccept(['jpg', 'jpeg', 'png'])
      },
      PlanType: PlanType
    };
  },


  watch: {
    dialogVisible: function dialogVisible(val) {
      if (this.$refs.form) {
        var form = this.$refs.form;
        form.resetFields();
        form.clearValidate();
      }
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('update:visible', false);
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.closeDialog();
      this.$emit('save-success');
    },
    beforeUpload: function beforeUpload(file) {
      var isLt = file.size / 1024 > 500;
      if (isLt) {
        Message.warning('截图大小不得超过500KB');
      }
      return !isLt;
    },
    successUpload: function successUpload(response) {
      if (response.code === 0) {
        this.formValue.image = response.data.url;
        this.formValue.url = response.data.file_path.substring(response.data.file_path.indexOf('mws-files://') + 'mws-files://'.length);
      } else {
        Message.error(response.msg);
      }
    },
    submit: function submit() {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          grantRevoke({
            reason: _this.formValue.reason,
            url: _this.formValue.url,
            id: _this.authorizeInfo.id
          }).then(function () {
            _this.handleSaveSuccess();
          }).finally(function () {
            _this.loading = false;
          });
        }
      });
    },
    cancel: function cancel() {
      this.closeDialog();
      this.$emit('cancel');
    }
  }
};